import { InnerNavigatorOption } from 'components/ui/InnerNavigator';
import { usePermissions } from 'hooks';

export function AiUserInnerOptions() {
  const { checkUserPermission } = usePermissions();
  const options: InnerNavigatorOption[] = [
    {
      title: 'Usuários IA',
      route: '/settings/ai-users',
      hasPermission: checkUserPermission('listUser'),
    },
    {
      title: 'Novo usuários IA',
      route: '/settings/ai-users/new',
      hasPermission: checkUserPermission('insertUser'),
    },
  ];

  return { options };
}
